
export const BASE_DISCIPLINE_COLOR = '#006FFF'
export const BASE_DISCIPLINE_COLOR = '#006FFF'